import { useQuery } from "@tanstack/react-query";
import { request } from "../api";
import { GET_WORKOUT_COUNT } from "../querykeys";
import { WorkOut } from "src/types/WorkOut";

export const useCodeLookup = () => {
  return useQuery({
    queryKey: [GET_WORKOUT_COUNT],
    queryFn: async () => {
      const result = await request<WorkOut[]>({
        method: "GET",
        url: "/codes/workout-count",
      });
      return result || [];
    },
  });
};
